import React from 'react'
import PageHeader from '../../componentsII/PageHeader';
import api from '../../axios/api';
import { TableContainer, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Table, Paper, Switch, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Menu } from '@mui/material';
import { useEffect, useState } from 'react';
import { X, Trash2 as DeleteIcon,PenBoxIcon, PlusIcon } from 'lucide-react';
import { format } from "date-fns";
import CustomButton from '../../componentsII/Buttons';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../redux/slices/notificationSlice';
import AddUpdateRefrigerantTypeModal from '../../components/Masters/RefrigerantTypeMaster/AddUpdateRefrigerantTypeModal';
import { TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import debounce from 'lodash/debounce';
import { Search } from 'lucide-react';

const RefrigerantMaster = () => {
    const dispatch = useDispatch();
    const [RefrigerantTypes, setRefrigerantTypes] = useState([]);
    const [isAddUpdateRefrigerantModalOpen, setIsAddUpdateRefrigerantModalOpen] = useState(false);
    const [selectedRefrigerant, setSelectedRefrigerant] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [RefrigerantTypeToDelete, setRefrigerantTypeToDelete] = useState(null);

    const [totalRefrigerantTypes, setTotalRefrigerantTypes] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [filters, setFilters] = useState({
        search: '',
        status: 'ALL',
        sortBy: 'created_at',
        sortOrder: 'desc'
    });

    const getRefrigerant = async (pageNumber = page, limit = rowsPerPage, filterParams = filters) => {
        try {
            const response = await api.get('/admin/getRefrigerantTypes', {
                params: {
                  page: pageNumber + 1,
                  limit,
                  search: filterParams.search,
                  status: filterParams.status === 'ALL' ? '' : filterParams.status,
                  sortBy: filterParams.sortBy,
                  sortOrder: filterParams.sortOrder
                }
              });
            setRefrigerantTypes(response.data.data);
            setTotalRefrigerantTypes(response.data.total);
        } catch (error) {
            dispatch(showNotification({
                message: 'Failed to fetch refrigerant types',
                type: 'error',
            }));
        }
    }

    useEffect(() => {
        getRefrigerant();
    }, [page, rowsPerPage, filters]);

    const debouncedSearch = debounce((value) => { setFilters(prev => ({ ...prev, search: value })); setPage(0); }, 500);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleRemove = async (id) => {
        const RefrigerantType = RefrigerantTypes.find(type => type.id === id);
        setRefrigerantTypeToDelete(RefrigerantType);
        setDeleteDialogOpen(true);
    }

    const confirmDelete = async () => {
        try {
            setIsSubmitting(true);
            const response = await api.delete(`/admin/deleteRefrigerant/${RefrigerantTypeToDelete.id}`);
            if (response.data.status == 200) {
                dispatch(showNotification({
                    message: 'Refrigerant deleted successfully',
                    type: "success"
                }));
                getRefrigerant();
            } else {
                dispatch(showNotification({
                    message: 'Failed to delete Refrigerant',
                    type: "error"
                }));
            }
        } catch (error) {
            console.error('Error deleting Refrigerant:', error);
            dispatch(showNotification({
                message: 'An error occurred while deleting',
                type: "error"
            }));
        } finally {
            setIsSubmitting(false);
            setDeleteDialogOpen(false);
            setRefrigerantTypeToDelete(null);
        }
    }

    const handleEdit = async (user) => {
        setSelectedRefrigerant(user);
        setIsAddUpdateRefrigerantModalOpen(true);
    }

    const ActivateDeactivate = async (user) => {
        try {
            setIsSubmitting(true);
            const response = await api.post(`/admin/activateDeactivateRefrigerant/${user.id}`, {
                is_active: user.is_active == 1 ? 0 : 1
            });
            if (response.data.status == 200) {
                dispatch(showNotification({
                    message: user.is_active ? 'Refrigerant deactivated successfully' : 'Refrigerant activated successfully',
                    type: "success"
                }));
                getRefrigerant();
            } else {
                dispatch(showNotification({
                    message: user.is_active ? 'Failed to deactivate Refrigerant' : 'Failed to activate Refrigerant',
                    type: "error"
                }));
            }
        } catch (error) {
            console.error('Error activating/deactivating Refrigerant:', error);
            dispatch(showNotification({
                message: 'An error occurred',
                type: "error"
            }));
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <>
            <PageHeader title="Refrigerant Types">
                <div className="flex justify-end gap-5 items-center mt-5">
                    <div className="flex items-center gap-4 flex-1">
                        {/* Search Field */}
                        <TextField
                            size="small"
                            placeholder="Search refrigerant types..."
                            InputProps={{
                                startAdornment: <Search className="w-5 h-5 text-gray-500 mr-2" />,
                            }}
                            onChange={(e) => debouncedSearch(e.target.value)}
                            className="min-w-[300px]"
                        />

                        {/* Status Filter */}
                        <FormControl size="small" className="min-w-[150px]">
                            <InputLabel>Status</InputLabel>
                            <Select
                                value={filters.status}
                                label="Status"
                                onChange={(e) => {
                                    setPage(0);
                                    setFilters(prev => ({ ...prev, status: e.target.value }))
                                }}
                            >
                                <MenuItem value="ALL">All</MenuItem>
                                <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                                <MenuItem value="INACTIVE">INACTIVE</MenuItem>
                            </Select>
                        </FormControl>

                        {/* Sort By */}
                        <FormControl size="small" className="min-w-[150px]">
                            <InputLabel>Sort By</InputLabel>
                            <Select
                                value={filters.sortBy}
                                label="Sort By"
                                onChange={(e) => {
                                    setPage(0);
                                    setFilters(prev => ({ ...prev, sortBy: e.target.value }))
                                }}
                            >
                                <MenuItem value="created_at">Created Date</MenuItem>
                               <MenuItem value="refrigerant_name">Refrigerant Name</MenuItem>
                               <MenuItem value="formula">Formula</MenuItem>
                            </Select>
                        </FormControl>

                        {/* Sort Order */}
                        <FormControl size="small" className="min-w-[150px]">
                            <InputLabel>Order</InputLabel>
                            <Select
                                value={filters.sortOrder}
                                label="Order"
                                onChange={(e) => {
                                    setPage(0);
                                    setFilters(prev => ({ ...prev, sortOrder: e.target.value }))
                                }}
                            >
                                <MenuItem value="asc">Ascending</MenuItem>
                                <MenuItem value="desc">Descending</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <CustomButton
                        title='Add Refrigerant Type'
                        className="bg-green-600 hover:bg-green-700 text-white"
                        text={<><PlusIcon /> Add Refrigerant Type</>}
                        click={() => setIsAddUpdateRefrigerantModalOpen(true)}
                    />
                </div>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Refrigerant Name</TableCell>
                                <TableCell>Formula</TableCell>
                                <TableCell>Is Active</TableCell>
                                <TableCell>Created Date</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {RefrigerantTypes?.map((user) => (
                                <TableRow key={user.id}>
                                    <TableCell>{user.refrigerant_name}</TableCell>
                                    <TableCell>{user.formula}</TableCell>
                                    <TableCell>
                                        <Switch
                                            checked={user.is_active == "0" ? false : user.is_active == "1" ? true : null}
                                            color='success'
                                            onChange={(e) => ActivateDeactivate(user)}
                                            disabled={isSubmitting}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        {user.created_date ? format(new Date(user.created_date), "dd-MM-yyyy") : ""}
                                    </TableCell>
                                    <TableCell sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <IconButton
                                            size="small"
                                            onClick={() => handleEdit(user)}
                                            sx={{
                                                backgroundColor: '#16A34A',
                                                color: 'white',
                                                '&:hover': { backgroundColor: '#00bf46' },
                                                p: '8px',
                                            }}
                                        >
                                            <PenBoxIcon size={20} />
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            onClick={() => handleRemove(user.id)}
                                            sx={{
                                                backgroundColor: '#df3e3e',
                                                color: 'white',
                                                '&:hover': { backgroundColor: '#ff0000' },
                                                p: '8px',
                                            }}
                                        >
                                            <DeleteIcon size={20} />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    colSpan={5}
                                    count={totalRefrigerantTypes}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelDisplayedRows={({ from, to, count }) => 
                                        `Page ${page + 1} of ${Math.ceil(count / rowsPerPage)} | ${from}-${to} of ${count}`
                                      }
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </TableContainer>

                <Dialog
                    open={isAddUpdateRefrigerantModalOpen}
                    onClose={() => { setIsAddUpdateRefrigerantModalOpen(false); setSelectedRefrigerant(null) }}
                    maxWidth="sm"
                    fullWidth
                >
                    <div className="flex justify-between items-start pt-2 px-2">
                        <DialogTitle className="text-lg font-bold mt-1">
                            {selectedRefrigerant ? "Edit Refrigerant Type" : "Add New Refrigerant Type"}
                        </DialogTitle>
                        <X
                            className="w-6 h-6 cursor-pointer text-gray-500 hover:text-gray-700 transition"
                            onClick={() => { setIsAddUpdateRefrigerantModalOpen(false); setSelectedRefrigerant(null) }}
                        />
                    </div>
                    <DialogContent >
                        <AddUpdateRefrigerantTypeModal
                            refetch={getRefrigerant}
                            onClose={() => {
                                setIsAddUpdateRefrigerantModalOpen(false);
                                setSelectedRefrigerant(null);
                            }}
                            refrigerantId={selectedRefrigerant?.id}
                            initialData={selectedRefrigerant}
                        />
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={deleteDialogOpen}
                    onClose={() => setDeleteDialogOpen(false)}
                >
                    <DialogTitle>Confirm Delete</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete the equipment type "{RefrigerantTypeToDelete?.ind_gas_name}"? This action cannot be undone.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <div className="flex justify-end gap-5 items-center mt-5">
                            <CustomButton
                                className="bg-gray-500 hover:bg-gray-700 text-white"
                                text="Cancel"
                                disabled={isSubmitting}
                                click={() => setDeleteDialogOpen(false)}
                            />
                            <CustomButton
                                className="bg-red-600 hover:bg-red-700 text-white"
                                click={confirmDelete}
                                text='Delete'
                                disabled={isSubmitting}
                            />
                        </div>
                    </DialogActions>
                </Dialog>

            </PageHeader>
        </>
    )
}

export default RefrigerantMaster